module.exports = {
      id: "vikatanplay-usage",
      viewBox: "0 0 22.5 23.3",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#vikatanplay",
      toString: function () {
        return this.url;
      }
    }